import { render, staticRenderFns } from "./DepartList.vue?vue&type=template&id=072304e1&scoped=true"
import script from "./DepartList.vue?vue&type=script&lang=js"
export * from "./DepartList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072304e1",
  null
  
)

export default component.exports